export default {

    isTouchDevice: function () {
      let _navi = navigator;
      return (('ontouchstart' in window) || (_navi.MaxTouchPoints > 0) || (_navi.msMaxTouchPoints > 0));
      /* browser with either Touch Events of Pointer Events
      running on touch-capable device */
    },
  
    isiOS() {
      let ua = {};
      ua.name = window.navigator.userAgent.toLowerCase();
  
      ua.isIE = (ua.name.indexOf('msie') >= 0 || ua.name.indexOf('trident') >= 0);
      ua.isiPhone = ua.name.indexOf('iphone') >= 0;
      ua.isiPod = ua.name.indexOf('ipod') >= 0;
      ua.isiPad = ua.name.indexOf('ipad') >= 0;
  
      return (ua.isiPhone || ua.isiPod || ua.isiPad);
    },
  
    isPc() {
      let ua = window.navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
        // スマートフォン用コード
        return false;
      } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
        // タブレット用コード
        return false;
      } else {
        // PC用コード
        return true;
      }
    },
  
    isClippingCornerEnable() {
      let ua = window.navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
        // スマートフォン用コード
        return false;
      } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
        // タブレット用コード
        return false;
      } else {
        // PC用コード
        return !!(window.EDITOR_GLOBAL["$d"]["clippingCornerEventEnable"]);
      }
    },
  
    isChrome() {
      return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    },
  
    isFireFox() {
      let isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
      return isBrowser && /Firefox/i.test(navigator.userAgent);
    },
  
    isAndroid() {
      let isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
      return isBrowser && /Android/i.test(navigator.userAgent);
    },
  
    isMacOs() {
      return window.navigator.platform.indexOf('Mac') >= 0;
    },
  
    isSafari() {
      return window.navigator.userAgent.indexOf('Safari') >= 0;
    },
  
    isiPad(){
      let userAgent = window.navigator.userAgent.toLowerCase();
  
      return userAgent.indexOf('ipad') >= 0;
    }
  }